import { topicsData } from '@/mocks/home';

const colorClasses: Record<string, { bg: string; text: string; heat: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-800', heat: 'text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-800', heat: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800', heat: 'text-secondary-600' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全网漫画爱好者都在讨论的话题标签</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => {
            const c = colorClasses[topic.color] || colorClasses.primary;
            return (
              <a
                key={topic.slug}
                href="#ranking"
                className={`flex items-center gap-2 px-4 py-2.5 ${c.bg} rounded-full cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap`}
              >
                <span className={`text-sm font-medium ${c.text}`}>{topic.name}</span>
                <span className={`text-xs font-medium ${c.heat}`}>{topic.heat}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}